import React, { memo, useState, useMemo, useEffect } from 'react';
import { CategoryLandingPageSectionBlokProps } from './CategoryLandingPage';
import CategoryLandingPageSideBarMobileDropdownItem from './CategoryLandingPageSideBarMobileDropdownItem';
import classNames from 'classnames';
import { formatStringForUrl } from '../../utils/formatStringForUrl/formatStringForUrl.util';

interface CategoryLandingPageSideBarMobileDropdownProps {
  categoryLandingPageSections: CategoryLandingPageSectionBlokProps[];
  activeCategoryLandingPageSectionName: string;
  setActiveCategoryLandingPageSection: (state: string) => void;
}

const CategoryLandingPageSideBarMobileDropdown: React.FC<
  CategoryLandingPageSideBarMobileDropdownProps
> = ({
  categoryLandingPageSections,
  activeCategoryLandingPageSectionName,
  setActiveCategoryLandingPageSection,
}) => {
  const [isMobileDropdownVisible, setIsMobileDropdownVisible] =
    useState<boolean>(false);

  const getActiveSectionIdx: () => number = () => {
    const index: number = categoryLandingPageSections.findIndex(
      (categoryLandingPageSection: CategoryLandingPageSectionBlokProps) =>
        formatStringForUrl(categoryLandingPageSection?.heading) ===
        formatStringForUrl(activeCategoryLandingPageSectionName)
    );
    return index || 0;
  };

  const [activeSectionIdx, setActiveSectionIdx] = useState<number>(
    getActiveSectionIdx()
  );

  useEffect(() => {
    setActiveSectionIdx(getActiveSectionIdx());
  }, [activeCategoryLandingPageSectionName]);

  return (
    <div>
      <button
        className="w-full h-12 flex items-center justify-between bg-[#0B212E] px-4 py-3 rounded-lg text-system/white pointer-events-auto"
        onClick={() => setIsMobileDropdownVisible(!isMobileDropdownVisible)}
      >
        <div className="flex items-center justify-start gap-x-2">
          <div className="w-6 h-6 rounded-full flex items-center justify-center bg-[#006FA7]">
            <p className="font-dm-serif-display">{activeSectionIdx + 1}</p>
          </div>
          <p className="text-system/white">
            {categoryLandingPageSections[activeSectionIdx]?.heading}
          </p>
        </div>

        <div
          className={classNames(
            "w-6 h-6 bg-[url('/svgs/dropdown-arrow.svg')] bg-no-repeat",
            {
              'rotate-0': !isMobileDropdownVisible,
              'rotate-180': isMobileDropdownVisible,
            }
          )}
        ></div>
      </button>
      {isMobileDropdownVisible && (
        <ul className="border border-[#0B212E] rounded-b-lg px-4 pt-2 pb-2 -translate-y-2 pointer-events-auto">
          {categoryLandingPageSections.map(
            (
              categoryLandingPageSection: CategoryLandingPageSectionBlokProps,
              index: number
            ) => (
              <CategoryLandingPageSideBarMobileDropdownItem
                key={categoryLandingPageSection._uid}
                categoryLandingPageSection={categoryLandingPageSection}
                isLastItem={categoryLandingPageSections.length - 1 == index}
                itemIdx={index}
                activeCategoryLandingPageSection={
                  activeCategoryLandingPageSectionName
                }
                setActiveCategoryLandingPageSection={
                  setActiveCategoryLandingPageSection
                }
              />
            )
          )}
        </ul>
      )}
    </div>
  );
};

export default CategoryLandingPageSideBarMobileDropdown;
